import React from 'react';
import Page from '../core/screens/Page';

import '../css/screens/SitePolicyPage.scss';
import Grid from '../responsive/Grid';
import ContentBuilder from '../core/ContentBuilder';

export default class SitePolicyPage extends Page
{

	_parseContent(items)
	{
		if(!Array.isArray(items)) return;
		let parsed = {items: [], content: null, parent: null, indent: -1};
		let current = parsed;
		let prev;
		items.map((e, i) =>{
			let indent = e.replace(/^(\t+)(.*?)$/, '$1');
			indent = indent.split('\t').length - 1;
			while(indent <= current.indent)
			{
				current = current.parent;
			}
			if (indent - 1 > current.indent)
			{
				current = prev;
			}
			let item = {items: [], content: e.replace(/^\t+/, ''), parent: current, indent: indent};
			current.items.push(item);
			prev = item;
		});

		return this._parseItems(parsed.items);
	}

	_katakana = ["ア","イ","ウ","エ","オ","カ","キ","ク","ケ","コ","サ","シ","ス","セ","ソ","タ","チ","ツ","テ","ト","ナ","ニ","ヌ","ネ","ノ","ハ","ヒ","フ","ヘ","ホ","マ","ミ","ム","メ","モ","ヤ","ユ","ヨ","ラ","リ","ル","レ","ロ","ワ","ヲ","ン"];
	_numbers = ["０","１","２","３","４","５","６","７","８","９"];

	_parseItems(items, indent = 0)
	{
		return (<ol key={indent}>
			{items.map((e, i)=>{
				let children;
				if(e.items.length > 0) children = this._parseItems(e.items, indent + 1);
				let bullet;
				let numIndex = (i + 1).toString();
				numIndex = numIndex.split('');
				numIndex = numIndex.map((e, i) => {
					return this._numbers[Number(e)];
				});
				numIndex = numIndex.join('');
				switch(indent)
				{
					case 1:
						bullet = numIndex + '）';
						break;
					case 2:
						bullet = this._katakana[i] + ' ';
						break;
					default:
						bullet = numIndex + '. ';
						break;
				}
		
				return (<li key={i + '_' + indent} data-bullet={bullet}><div key={i + '_' + indent + '_'} className="text">{ContentBuilder.linkify(e.content)}</div>{children}</li>)
			})}
			</ol>
		)
	}

	render() {
		return this.wrap(
			<React.Fragment>
				{
					this.props.content.items.map((e, i)=>{
						let content = this._parseContent(e.content);
						return (
							<React.Fragment key={i + 'frag'}>
								<div className='header padding' key={i + 'header'}>
									<div className="title" key={i + 'title'}>{e.title}</div>
									<div className="subtitle" key={i + 'subtitle'}>{e.subtitle}</div>
								</div>
								<Grid key={i + 'grid'} className="content padding" cols={2} skip={1} breakpoints={{small: {cols: 4, skip: 0}}}>
									{content}
								</Grid>
						</React.Fragment>
		
						)
					})
				}
			</React.Fragment>
		);
	}
}
